





















import { Component, Vue } from 'vue-property-decorator'
import { State } from 'vuex-class'
import { ImagenesSatelitalesState } from '@/store/modules/imagenes-satelitales/types'
import ToggleSwitch from '@/components/ToggleSwitch.vue'

const IMAGENES_SATELITALES = 'imagenesSatelitales'

@Component({
  components: {
    ToggleSwitch
  }
})
export default class ImagenesSatelitalesControl extends Vue {
  @State(IMAGENES_SATELITALES) public imagenesSatelitales!: ImagenesSatelitalesState;
  path: string = '/imagenes-satelitales'

  updated () {
    const { path, query } = this.$route
    if (path === this.path && !query.type && this.imagenesSatelitales.etiquetas) {
      const type = Object.keys(this.imagenesSatelitales.etiquetas)[0]
      this.$router.push({
        query: { type }
      })
    }
  }

  get isSubmenuSelected () {
    return this.$route.path === '/imagenes-satelitales'
  }

  isImage (type: string) {
    return !!(this.imagenesSatelitales && this.imagenesSatelitales.imagenes && this.imagenesSatelitales.imagenes[type])
  }
}
